import { IconChevronLeft, IconChevronRight, IconChevronsLeft, IconChevronsRight } from '@/components/icons/Icons'

/*
  Pagination — pie de tabla: rango visible + navegación. Se ancla abajo del
  contenedor scrolleable para que la tabla scrollee sola y los controles
  queden siempre a la vista.

  Envuelve `.pagination` de index.css. Pensado para usarse con `usePagination()`.
*/
interface PaginationProps {
  page: number
  totalPages: number
  /** Total de filas ya filtradas (no el total del dataset). */
  total: number
  pageSize: number
  onPage: (page: number) => void
  /** Sustantivo para el rango: "movimientos", "facturas"… */
  noun?: string
}

export function Pagination({ page, totalPages, total, pageSize, onPage, noun = 'registros' }: PaginationProps) {
  if (total === 0) return null
  const desde = (page - 1) * pageSize + 1
  const hasta = Math.min(page * pageSize, total)

  return (
    <div className="pagination">
      <span className="pagination__range">
        {desde}–{hasta} de {total} {noun}
      </span>
      {totalPages > 1 && (
        <div className="pagination__controls">
          <button className="btn btn-sm btn-secondary" disabled={page <= 1} onClick={() => onPage(1)} title="Primera página" aria-label="Primera página">
            <IconChevronsLeft size={13} />
          </button>
          <button className="btn btn-sm btn-secondary" disabled={page <= 1} onClick={() => onPage(page - 1)} title="Anterior" aria-label="Página anterior">
            <IconChevronLeft size={13} /> Anterior
          </button>
          <span className="pagination__page">{page} / {totalPages}</span>
          <button className="btn btn-sm btn-secondary" disabled={page >= totalPages} onClick={() => onPage(page + 1)} title="Siguiente" aria-label="Página siguiente">
            Siguiente <IconChevronRight size={13} />
          </button>
          <button className="btn btn-sm btn-secondary" disabled={page >= totalPages} onClick={() => onPage(totalPages)} title="Última página" aria-label="Última página">
            <IconChevronsRight size={13} />
          </button>
        </div>
      )}
    </div>
  )
}
